/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetLinkShortenerLinkParams,
  LinkShortenerLink,
  LinkShortenerLinkRequestInput,
  PaginatedLinkShortenerLinks,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Link
 */
export const createLinkShortenerLink = (

 signal?: AbortSignal
) => {


      return axiosClient<LinkShortenerLink>(
      {url: `/link_shortener/links`, method: 'POST', signal
    },
      );
    }




export const getCreateLinkShortenerLinkMutationKey = () => ['createLinkShortenerLink'] as const;

export const getCreateLinkShortenerLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext> => {

const mutationKey = getCreateLinkShortenerLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkShortenerLink>>, void> = () => {


          return  createLinkShortenerLink()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkShortenerLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkShortenerLink>>>

    export type CreateLinkShortenerLinkMutationError = ErrorType<void>


    /**
 * @summary Create Link
 */
export const useCreateLinkShortenerLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createLinkShortenerLink>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateLinkShortenerLinkMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Links
 */
export const listLinkShortenerLinks = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedLinkShortenerLinks>(
      {url: `/link_shortener/links`, method: 'GET', signal
    },
      );
    }




export const getListLinkShortenerLinksQueryKey = () => {
    return [
    'link_shortener','links'
    ] as const;
    }


export const getListLinkShortenerLinksQueryOptions = <TData = Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListLinkShortenerLinksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkShortenerLinks>>> = ({ signal }) => listLinkShortenerLinks(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData>
}

export type ListLinkShortenerLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkShortenerLinks>>>
export type ListLinkShortenerLinksQueryError = ErrorType<void>


/**
 * @summary List of Links
 */

export function useListLinkShortenerLinks<TData = Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkShortenerLinksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Link
 */
export const deleteLinkShortenerLink = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/link_shortener/links/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteLinkShortenerLinkMutationKey = () => ['deleteLinkShortenerLink'] as const;

export const getDeleteLinkShortenerLinkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinkShortenerLink>>, TError,DeleteLinkShortenerLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLinkShortenerLink>>, TError,DeleteLinkShortenerLinkMutationVariables, TContext> => {

const mutationKey = getDeleteLinkShortenerLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLinkShortenerLink>>, DeleteLinkShortenerLinkMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteLinkShortenerLink(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLinkShortenerLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLinkShortenerLink>>>

    export type DeleteLinkShortenerLinkMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteLinkShortenerLinkMutationVariables = {id: string}

    /**
 * @summary Delete Link
 */
export const useDeleteLinkShortenerLink = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLinkShortenerLink>>, TError,DeleteLinkShortenerLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteLinkShortenerLink>>,
        TError,
        DeleteLinkShortenerLinkMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLinkShortenerLinkMutationOptions(options), queryClient);
    }
    /**
 * @summary Link Details
 */
export const getLinkShortenerLink = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetLinkShortenerLinkParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<LinkShortenerLink>(
      {url: `/link_shortener/links/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLinkShortenerLinkQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetLinkShortenerLinkParams>,) => {
    return [
    'link_shortener','links',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLinkShortenerLinkQueryOptions = <TData = Awaited<ReturnType<typeof getLinkShortenerLink>>, TError = ErrorType<StandardError | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetLinkShortenerLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetLinkShortenerLinkQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkShortenerLink>>> = ({ signal }) => getLinkShortenerLink(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData>
}

export type GetLinkShortenerLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkShortenerLink>>>
export type GetLinkShortenerLinkQueryError = ErrorType<StandardError | void>


/**
 * @summary Link Details
 */

export function useGetLinkShortenerLink<TData = Awaited<ReturnType<typeof getLinkShortenerLink>>, TError = ErrorType<StandardError | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetLinkShortenerLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLinkShortenerLinkQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Link
 */
export const updateLinkShortenerLink = (
    id: MaybeRefOrGetter<string>,
    linkShortenerLinkRequestInput: MaybeRefOrGetter<LinkShortenerLinkRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
linkShortenerLinkRequestInput = toValue(linkShortenerLinkRequestInput);

      return axiosClient<LinkShortenerLink>(
      {url: `/link_shortener/links/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: linkShortenerLinkRequestInput, signal
    },
      );
    }




export const getUpdateLinkShortenerLinkMutationKey = () => ['updateLinkShortenerLink'] as const;

export const getUpdateLinkShortenerLinkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,UpdateLinkShortenerLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,UpdateLinkShortenerLinkMutationVariables, TContext> => {

const mutationKey = getUpdateLinkShortenerLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLinkShortenerLink>>, UpdateLinkShortenerLinkMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateLinkShortenerLink(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLinkShortenerLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateLinkShortenerLink>>>
    export type UpdateLinkShortenerLinkMutationBody = LinkShortenerLinkRequestInput
    export type UpdateLinkShortenerLinkMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateLinkShortenerLinkMutationVariables = {id: string;data: LinkShortenerLinkRequestInput}

    /**
 * @summary Update Link
 */
export const useUpdateLinkShortenerLink = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,UpdateLinkShortenerLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateLinkShortenerLink>>,
        TError,
        UpdateLinkShortenerLinkMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLinkShortenerLinkMutationOptions(options), queryClient);
    }
